import { tryParseJSON } from "@/components/shared/util";
import { patientNamespace } from "@/store/modules/patient";
import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
const registrationChannel = "REGISTRATION_CHANNEL";

@Component({})
export default class ExternalSite extends Vue {
  @Getter("vars", patientNamespace)
  vars!: any;

  // set in mounted
  url = "";
  message: any = null;
  hidePopup = false;

  mounted() {
    this.url = _.get(this.vars, "uiConfig.elements.registerUrl", "");
  }

  handler(e: any) {
    // Get the sent data
    const data = tryParseJSON(e.data, null);
    if (data && data.channel === registrationChannel) {
      if (data.message.action === "CLOSE") {
        this.hidePopup = true;
      }
    }
  }

  created() {
    window.addEventListener("message", this.handler);
  }

  beforeDestroy() {
    window.removeEventListener("message", this.handler);
  }
}
